"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mapInvalidProjectProductOptionsToValidOnes;
const OPTION_KEY_MAPPINGS = {
  'baby-board-book': {
    page_count: 'standard_page_count'
  }
};
function mapInvalidProjectProductOptionsToValidOnes(sku, projectProductOptions) {
  return Object.entries(projectProductOptions).reduce((mappedOptionsObj, _ref) => {
    let [optionKey, optionValue] = _ref;
    var _a;
    const mappedKey = (_a = OPTION_KEY_MAPPINGS[sku]) === null || _a === void 0 ? void 0 : _a[optionKey];
    return Object.assign(Object.assign({}, mappedOptionsObj), mappedKey ? {
      // Eventually, if we want, we can add in value mapping as well.
      [mappedKey]: optionValue
    } : {
      [optionKey]: optionValue
    });
  }, {});
}